import { ApiModel } from '@composable-api/api.model'

interface Attributes {
    [ReferralCodeModel.ATTR_ID]: number
    [ReferralCodeModel.ATTR_LOYALTY_PROGRAM_ID]: number
    [ReferralCodeModel.ATTR_REFERRAL_CODE]: string
}

interface Embeds {
}

export class ReferralCodeModel extends ApiModel<Attributes, Embeds> {
    static key = 'ReferralCodeModel'

    static readonly ATTR_ID = 'id'
    static readonly ATTR_LOYALTY_PROGRAM_ID = 'loyalty_program_id'
    static readonly ATTR_REFERRAL_CODE = 'referral_code'

    get id() {
        return this._getAttribute(ReferralCodeModel.ATTR_ID)
    }

    get loyaltyProgramId() {
        return this._getAttribute(ReferralCodeModel.ATTR_LOYALTY_PROGRAM_ID)
    }

    get referralCode() {
        return this._getAttribute(ReferralCodeModel.ATTR_REFERRAL_CODE)
    }
}
